import { Map, useMapsLibrary } from '@vis.gl/react-google-maps'
import React, { useCallback, useState } from 'react'
import { useStore } from 'react-admin'

import { Circle } from './Circle'
import { ClusteredMarkers } from './Clusterer'
import HoverInfoWindow from './HoverInfoWindow'
import { VehiclePathOverlay } from './PathOverlay'
import SearchCircle from './SearchCircle'
import { lightTheme } from '../../config/theme'

const MAP_DEFAULT_ZOOM = 15

const GoogleMapContainer = ({ circles = [], markers = [], polylines = [] }) => {
  const [selectedTelemetryKey, setSelectedTelemetryKey] = useState(null)
  const [mapTypeId, setMapTypeId] = useStore('google-maps-type', 'roadmap')
  const [hoverInfo, setHoverInfo] = useState(null)

  const onMapClick = useCallback(() => {
    if (selectedTelemetryKey) {
      setSelectedTelemetryKey(null)
    }
  }, [selectedTelemetryKey])

  const coreLib = useMapsLibrary('core')

  if (!coreLib) {
    return null
  }

  let defaultBounds
  if (markers.length && typeof coreLib.LatLngBounds === 'function') {
    const bounds = new coreLib.LatLngBounds()
    if (typeof bounds?.extend === 'function' && typeof bounds.toJSON === 'function') {
      markers.forEach((marker) => bounds.extend(marker.position))
      defaultBounds = bounds.toJSON()
    }
  }

  return (
    <Map
      defaultZoom={MAP_DEFAULT_ZOOM}
      mapTypeId={mapTypeId}
      mapId={'telematics-map'}
      style={{ borderRadius: '5px' }}
      onMapTypeIdChanged={({ map }) => setMapTypeId(map.getMapTypeId())}
      defaultCenter={markers?.[0]?.position || circles?.[0]?.center}
      defaultBounds={defaultBounds}
      onClick={onMapClick}
      maxZoom={20}
      // reuseMaps={true} This cause issues with duplicated markers in cluster.
    >
      {markers && (
        <ClusteredMarkers
          telemetries={markers}
          selectedTelemetryKey={selectedTelemetryKey}
          setSelectedTelemetryKey={setSelectedTelemetryKey}
          setHoverInfo={setHoverInfo}
        />
      )}
      {hoverInfo && hoverInfo.object?.speedingData && (
        <HoverInfoWindow
          record={hoverInfo.object?.record}
          speedingData={hoverInfo.object.speedingData}
          x={hoverInfo.x}
          y={hoverInfo.y}
        />
      )}
      {circles.map((circle, index) =>
        circle.type === 'search' ? (
          <SearchCircle key={index} initialCenter={circle.center} />
        ) : (
          <Circle
            key={index}
            radius={circle.radius}
            center={circle.center}
            strokeColor="transparent"
            fillColor={lightTheme.palette.primary[500]}
            fillOpacity={0.3}
          />
        ),
      )}

      {polylines.length > 0 && (
        <VehiclePathOverlay
          polylines={polylines}
          setHoverInfo={setHoverInfo}
          isInfoWindowOpen={selectedTelemetryKey !== null}
        />
      )}
    </Map>
  )
}

const GoogleMap = (props) => <GoogleMapContainer {...props} />

export default GoogleMap
